import React from 'react';
import { useHistory } from 'react-router-dom';
import WizardStep4 from '../components/WizardStep4';
import { useSelector, useDispatch } from 'react-redux';
import {
    setPaymentData,
    setUsersPayer,
    setStartDate,
    setGroups,
    setChName,
    setCurseHadings,
    setUsersParticipant,
    setPromotionsSalesIDArray,
    setPromotionsData,
} from '../reducers/reposReducers';

const Wybor_opcji_4_forma_platnosci = () => {
    
    const dispatch = useDispatch();
    const dispatch1 = useDispatch();
    const dispatch2 = useDispatch();
    const dispatch3 = useDispatch();

    const saveStateBD = {
        
        getGroup: useSelector((state) => state.repos.groups),
        dateToBay: useSelector((state) => state.repos.date),
        users: useSelector((state) => state.repos.users),
        usersParticipant: useSelector((state) => state.repos.usersParticipant),
        courseHeading: useSelector((state) => {
            return state.repos.coursesHeadings;
        }),
    };
    let key = useSelector((state) => state.repos.chName);
    let getGroup = useSelector((state) => state.repos.groups);
    let dateToBay = useSelector((state) => state.repos.date);
    let users = useSelector((state) => state.repos.users);
    let usersParticipant = useSelector((state) => state.repos.usersParticipant);
    let courseHeading = useSelector((state) => {
        return state.repos.coursesHeadings;
    });

    if (users) {
        localStorage.setItem('steps1', JSON.stringify(users));
        localStorage.setItem('steps2', JSON.stringify(usersParticipant));
        localStorage.setItem('steps3', JSON.stringify(dateToBay));
        localStorage.setItem('steps4', JSON.stringify(getGroup));
        localStorage.setItem('steps4', JSON.stringify(getGroup));
    }

    if (!getGroup) {
        users = JSON.parse(localStorage.getItem('steps1'));
        usersParticipant = JSON.parse(localStorage.getItem('steps2'));
        dateToBay = JSON.parse(localStorage.getItem('steps3'));
        getGroup = JSON.parse(localStorage.getItem('steps4'));
        courseHeading = JSON.parse(localStorage.getItem('coursesHeadings'));
        key = localStorage.getItem('keyURL');

        if (!users || users == '') {
        
            history.push(`/LoginBuy/key=${localStorage.getItem('keyURL')}`);
        }
        dispatch(setUsersPayer(users));
        dispatch1(setUsersParticipant(usersParticipant));
        dispatch2(setStartDate(dateToBay));
        dispatch3(setGroups(getGroup));
        dispatch(setChName(key));
        dispatch(setCurseHadings(courseHeading));
    }

    const history = useHistory();
    const paymentData = useSelector((state) => {
        return state.repos.payForm;
    });

    const paymentDataChanged = (paymentData) => {
        if (
            typeof paymentData === 'object' &&
            paymentData !== null &&
            typeof paymentData.selectedPaymentMethod === 'number' &&
            paymentData.selectedPaymentMethod > 0
        ) {
            switch (paymentData.selectedPaymentMethod) {
                case 5:
                    // przelewy24
                    localStorage.setItem('payForm', JSON.stringify(paymentData));
                    localStorage.setItem('payment', paymentData.selectedPaymentMethod);
                    dispatch(setPaymentData(paymentData));

                    break;

                case 3:
                    // karta płatnicza
                    if (
                        typeof paymentData.selectedCard === 'number' &&
                        paymentData.selectedCard > 0
                    ) {
                        localStorage.setItem('payForm', JSON.stringify(paymentData));
                        localStorage.setItem('payment', paymentData.selectedPaymentMethod);
                        localStorage.setItem('card', paymentData.selectedCard);
                        dispatch(setPaymentData(paymentData));
                    }
                    break;
            }
        }
        dispatch(setPaymentData(paymentData));
    };

    // const courseHeading = useSelector((state) => {
    //     return state.repos.coursesHeadings;
    // });

    const selectedProduct = useSelector((state) => {
        return state.repos.groups;
    });

    const promotionsData = useSelector((state) => {
        return state.repos.promotionsData;
    });

    const promotionsDataChanged = (promotionsData) => {
        const selectedPromotionIds = [];
        for (const selectedPromo of promotionsData.selectedPromotions) {
            selectedPromotionIds.push(selectedPromo.promotionId);
        }

        dispatch(setPromotionsData(promotionsData));
        dispatch(setPromotionsSalesIDArray(selectedPromotionIds));
    };

    const selectedParticipant = useSelector((state) => {
        return state.repos.usersParticipant;
    });

    const proceed = () => {
        history.push('/Wybor_opcji_5_raty');
    };

    return (
        <WizardStep4
            getGroup={getGroup}
            dateToBay={dateToBay}
            users={users}
            usersParticipant={usersParticipant}
            finished={proceed}
            paymentData={paymentData}
            promotionsData={promotionsData}
            courseHeading={courseHeading}
            selectedProduct={selectedProduct}
            selectedParticipant={selectedParticipant}
            onPaymentDataChange={(paymentData) => {
                paymentDataChanged(paymentData);
            }}
            onPromotionsChange={(promotionsData) => {
                promotionsDataChanged(promotionsData);
            }}
        ></WizardStep4>
    );
};
export default Wybor_opcji_4_forma_platnosci;
